import * as types from "./types";

const initialState = {
  signPad: null,
  signType: null,
  isEmpty: true,
};

export default function signatureReducer(state: any = initialState, action) {
  switch (action.type) {
    case types.SET_SIGNATURE_PAD.SUCCESS:
      return {
        ...state,
        signPad: action.payload,
      };

    case types.SET_SIGNATURE_TYPE.SUCCESS:
      return {
        ...state,
        signType: action.payload,
      };

    case types.SET_SIGNATURE_EMPTY.SUCCESS:
      return {
        ...state,
        isEmpty: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/reducer.js